import { useCallback, useEffect, useState } from 'react';
import { Flex } from 'antd';
import {
  useAppSelector,
  useFindCountryTypeByType,
  useStatusFinderByNum,
} from '@Hooks/index';
import { useGetHrmRequestFormQuery } from '@Store/api/basicHrmApiSlice';
import { getModalRecordKey } from '@Store/selectors/modalSelector';
import { getDocument } from '@Features/utils/document';
import {
  useDownloadDocumentQuery,
  useFormListMutation,
} from '@Store/api/dmsApiSlice';
import { useGetUserInfoMutation } from '@Store/api/userApiSlice';
import { User } from '@Types/index';
import { getOverseasSponsorsDictSelector } from '@Store/selectors/dictionarySelector';

import fieldSource from './FieldSource';
import styles from './view-form.module.css';
import { getDocumentFolder } from '../utils/document';

const RequestViewForm: React.FC = () => {
  const { findStatus } = useStatusFinderByNum('Overseas');
  const { findCountryType } = useFindCountryTypeByType();

  const sponsors = useAppSelector(getOverseasSponsorsDictSelector);
  const requestId = useAppSelector(getModalRecordKey);

  const { data } = useGetHrmRequestFormQuery(requestId!, {
    skip: !requestId,
    refetchOnMountOrArgChange: true,
  });
  const [getFormList] = useFormListMutation();
  const [getUser] = useGetUserInfoMutation();

  const [user, setUser] = useState<User | null>(null);
  const [documentId, setDocumentId] = useState('');

  const { data: imageURL } = useDownloadDocumentQuery(documentId || '', {
    skip: !documentId,
  });

  useEffect(() => {
    if (!data?.requestId) {
      return;
    }

    getUser({ empNo: data.empNumber })
      .unwrap()
      .then((userData) => {
        setUser(userData);
      });

    if (!data?.filepath) {
      return;
    }

    const documentFolderPath = getDocumentFolder(data.requestId);

    getFormList(documentFolderPath)
      .unwrap()
      .then((response) => {
        const matchedDocument = getDocument(response, data.filepath);

        if (matchedDocument) {
          setDocumentId(matchedDocument.documentId);
        }
      });
  }, [data]);

  const handleDownloadClick = useCallback((): void => {
    if (imageURL && data?.filepath) {
      const a = document.createElement('a');
      a.href = imageURL;
      a.download = data.filepath;
      document.body.appendChild(a);
      a.click();
      a.remove();
    }
  }, [imageURL, data?.filepath]);

  if (!data) return null;

  return (
    <Flex className={styles.viewForm} vertical>
      {fieldSource(
        data,
        findCountryType,
        findStatus,
        documentId,
        user,
        sponsors,
        handleDownloadClick
      ).map((item) => (
        <div className={styles.viewItem} key={item.label}>
          <span>{item.label}</span>
          <span className={styles.viewItemValue}>{item.value}</span>
        </div>
      ))}
    </Flex>
  );
};

export default RequestViewForm;
